const percentFormatter = new Intl.NumberFormat("sv-se", {
	style: "percent",
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

export const formatPercentage = (value: string) => percentFormatter.format(Number(value) / 100);
